// extracted by mini-css-extract-plugin
export var label = "_95-1";
export var reminder = "_95-0";